export const awsJdbcDriverConfigSnippet =
`spring:
  datasource:
    url: jdbc:aws-wrapper:postgresql://dbclusterhost:5432/dbname?wrapperPlugins=auroraConnectionTracker,failover,efm
    driver-class-name: software.amazon.jdbc.Driver
    username: dbusername
    password: dbpassword
    hikari:
      minimum-idle: 5
      maximum-pool-size: 50
      max-lifetime: 300000 # 5m
      connection-timeout: 7500 # 7,5s
      exception-override-class-name: software.amazon.jdbc.util.HikariCPSQLException
`
